import {CssBaseline, MetrikaProvider, Notifications, ThemeProvider} from '@yandex-delivery/blocks'
import {ThemeProviderv2} from '@yandex-delivery/blocks/theme'
import {DevTools} from '@yandex-delivery/modules/dev-tools'
import {ErrorBoundary, RumObservableRoot} from '@yandex-delivery/modules/rum'
import React from 'react'
import {Provider} from 'react-redux'
import {config, isAuthMode} from 'src/shared/config'
import i18n from 'src/shared/i18n'

import {ErrorNotification} from '../pages/home/components/error-notification'
import './devtools-overrides'

import {Routes} from './Routes'
import {store} from './store'

const AppContent: React.FC = () => {
  return (
    <ErrorBoundary i18n={i18n.print}>
      <Provider store={store}>
        <MetrikaProvider brand={config.brand} yandexID={config.yaMetrikaID}>
          <RumObservableRoot>
            <Notifications>
              <Routes />
              <ErrorNotification />
            </Notifications>
          </RumObservableRoot>
          <DevTools config={config.devTools} />
        </MetrikaProvider>
      </Provider>
    </ErrorBoundary>
  )
}

/**
 * Trunk-провайдеры для обычной шарилки (apiMode !== 'auth')
 */
const LegacyAppShell: React.FC = () => (
  <ThemeProviderv2 dir={config.dir} locale={config.lang}>
    <ThemeProvider>
      <CssBaseline />
      <AppContent />
    </ThemeProvider>
  </ThemeProviderv2>
)

/**
 * Auth-провайдеры с поддержкой темной темы
 */
const AuthAppShell: React.FC = () => {
  // Dynamic imports for auth-specific theme
  require('./theme-variables')

  const {RouteMuiThemeProvider} = require('./RouteMuiThemeProvider')
  const {RouteThemeProvider} = require('./RouteThemeProvider')

  return (
    <RouteThemeProvider>
      <RouteMuiThemeProvider>
        <AppContent />
      </RouteMuiThemeProvider>
    </RouteThemeProvider>
  )
}

// Load theme-overrides only for auth mode
if (isAuthMode) {
  require('./load-theme-overrides')
}

export const App: React.FC = () => (isAuthMode ? <AuthAppShell /> : <LegacyAppShell />)
